// endpoints for general insurance import flow (upload, validation, list invalids, corrections, finish)
export const giPolicyImportEndpoints = (builder) => ({
  // Upload GI excel file (FormData)
  uploadGIExcel: builder.mutation({
    query: (formData) => ({
      url: '/gi-import-file/upload/excel-bulk',
      method: 'POST',
      body: formData,
    }),
    invalidatesTags: ['GIPolicyImport'],
  }),

  // Validations
  validateGIInsurers: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/validate/insurers/${batchId}`, method: 'GET' }),
  }),
  validateGIAgencies: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/validate/agencies/${batchId}`, method: 'GET' }),
  }),
  validateGIProducts: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/validate/products/${batchId}`, method: 'GET' }),
  }),
  validateGICustomers: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/validate/customers/${batchId}`, method: 'GET' }),
  }),
  validateGIFup: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/validate/fup/${batchId}`, method: 'GET' }),
  }),
  validateGIZones: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/validate/zones/${batchId}`, method: 'GET' }),
  }),
  validateGIPlans: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/validate/plans/${batchId}`, method: 'GET' }),
  }),

  // Lists of invalid distinct items (for resolution modals)
  getGIInvalidInsurers: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/invalid-insurers/${batchId}`, method: 'GET' }),
  }),
  getGIInvalidProducts: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/invalid-products/${batchId}`, method: 'GET' }),
  }),
  getGIInvalidAgencies: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/invalid-agencies/${batchId}`, method: 'GET' }),
  }),
  getGIInvalidCustomers: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/invalid-customers/${batchId}`, method: 'GET' }),
  }),
  getGIInvalidFup: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/invalid-fup/${batchId}`, method: 'GET' }),
  }),
  getGIInvalidZones: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/invalid-zones/${batchId}`, method: 'GET' }),
  }),
  getGIInvalidPlans: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/invalid-plans/${batchId}`, method: 'GET' }),
  }),

  // Apply a single correction (map/create)
  applyGICorrection: builder.mutation({
    query: (body) => ({ url: '/gi-import-file/apply-correction', method: 'POST', body }),
    invalidatesTags: ['GIPolicyImport'],
  }),

  // Bulk create customers and map them
  bulkCreateGICustomersAndApplyCorrection: builder.mutation({
    query: (body) => ({ url: '/gi-import-file/customers/bulk', method: 'POST', body }),
    invalidatesTags: ['GIPolicyImport'],
  }),

  // Finish GI import
  finishGIImport: builder.mutation({
    query: (body) => ({ url: '/gi-import-file/finish-import', method: 'POST', body }),
    invalidatesTags: ['GIPolicyImport'],
  }),

  // List batches maintained on backend
  getGIBatches: builder.query({
    query: ({ limit } = { limit: 100 }) => ({ url: `/gi-import-file/batches?limit=${limit}`, method: 'GET' }),
    providesTags: ['GIPolicyImport'],
  }),

  // Fetch per-batch import summary (total, success, duplicates, invalids)
  getGIImportSummary: builder.query({
    query: (batchId) => ({ url: `/gi-import-file/import-summary/${batchId}`, method: 'GET' }),
  }),

  // Fetch duplicate policy numbers for a batch
  getGIDuplicatePolicies: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/duplicate-policies/${batchId}`, method: 'GET' }),
  }),

  // Fetch motor import preview (staged rows)
  getGIMotorImportPreview: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/motor-preview/${batchId}`, method: 'GET' }),
  }),

  // Validate Vehicles
  validateGIVehicles: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/validate/vehicles/${batchId}`, method: 'GET' }),
  }),

  // List of invalid vehicles
  getGIInvalidVehicles: builder.mutation({
    query: (batchId) => ({ url: `/gi-import-file/invalid-vehicles/${batchId}`, method: 'GET' }),
  }),

  // Get active vehicles list
  getGIActiveVehicles: builder.query({
    query: () => '/gi-import-file/active-vehicles',
  }),
});
